import React from 'react';
import { Badge } from 'react-bootstrap';
import { BoardCard, SpalteDef } from './types';
import KanbanCard, { BoardActions } from './KanbanCard';

const HELLE_KOEPFE = ['warning', 'info', 'light'];

export default function KanbanColumn({ spalte, cards, actions, busyId }: {
  spalte: SpalteDef; cards: BoardCard[]; actions: BoardActions; busyId: number | null;
}) {
  const textCls = HELLE_KOEPFE.includes(spalte.farbe) ? 'text-dark' : 'text-white';
  return (
    <div>
      <div className={`d-flex align-items-center justify-content-between px-2 py-1 mb-2 rounded bg-${spalte.farbe} ${textCls}`}>
        <span className='fw-semibold' style={{ fontSize: '0.9rem' }}>{spalte.titel}</span>
        <Badge bg='light' text='dark'>{cards.length}</Badge>
      </div>
      {spalte.hinweis && (
        <div className='text-muted mb-2' style={{ fontSize: '0.72rem' }}>{spalte.hinweis}</div>
      )}
      {cards.length === 0 ? (
        <div className='text-muted fst-italic' style={{ fontSize: '0.8rem' }}>{spalte.leer}</div>
      ) : (
        cards.map((c) => <KanbanCard key={c.key} card={c} actions={actions} busyId={busyId} />)
      )}
    </div>
  );
}
